<template>
  <init-loader v-if="skeletonLoading"></init-loader>
  <v-card v-else :loading="loading">
    <v-alert
      v-if="!head.createdAt"
      prominent
      type="warning"
    >
      <v-row align="center">
        <v-col class="grow">페이지가 없습니다. 페이지를 만들어주세요.</v-col>
        <v-col class="shrink">
          <v-btn @click="openDialog" color="primary">만들기</v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <div v-else>
      <v-toolbar dense flat color="accent" dark>
        <v-toolbar-title>
          {{head.title}}
        </v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="show=!show"><v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
        <v-btn icon color="" :to="`/${category}/index?category=${head.category}`"><v-icon>mdi-view-list</v-icon></v-btn>
        <v-btn icon color="" @click="openDialog" v-if="$store.state.fireUser"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn icon color="" @click="remove" v-if="$store.state.fireUser"><v-icon>mdi-delete</v-icon></v-btn>
        <v-btn @click="dialogArticle=true" icon v-if="head.createdAt"><v-icon>mdi-plus</v-icon></v-btn>
      </v-toolbar>
      <v-card-text v-show="show">
        <v-card>
          <!-- <v-card-title>게시판 정보</v-card-title>
          <v-divider/> -->
          <v-subheader v-text="head.subtitle"/>
          <v-row dense align="start" justify="end">
            <v-col cols="4">
              <v-img :src="head.thumbnail" max-height="150" contain></v-img>
            </v-col>
            <v-col cols="8" class="pr-4 pb-4">
              <div style="white-space: pre-line">{{head.description}}</div>
              <div class="text-right font-italic mt-10" v-if="loading === false && head.createdAt">작성일: {{head.createdAt.toDate().toLocaleString()}}</div>
              <div class="text-right font-italic" v-if="loading === false && head.updatedAt">수정일: {{head.updatedAt.toDate().toLocaleString()}}</div>
              <div class="text-right font-italic">게시물 수: {{head.count}}</div>
            </v-col>
            <!-- <v-col cols="12">
            </v-col> -->
          </v-row>
        </v-card>
      </v-card-text>
      <board-article v-if="head.createdAt" :head="head" :collection="collection" :content="content" :dialogState="dialogArticle" @close-dialog="dialogArticle=false"></board-article>
    </div>
    <v-dialog v-model="dialog">
      <v-form v-model="valid" ref="form">
        <v-card :loading="loading">
          <v-card-title>
            작성
            <v-spacer/>
            <v-btn @click="save" icon><v-icon>mdi-content-save</v-icon></v-btn>
            <v-btn @click="dialog=false" icon><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-text-field v-model="head.category" outlined label="종류" :rules="[rule.required, rule.maxLength(20)]" required clearable />
            <v-text-field v-model="head.title" outlined label="제목" :rules="[rule.required, rule.maxLength(80)]" required clearable />
            <v-text-field v-model="head.subtitle" outlined label="부제" :rules="[rule.required, rule.maxLength(100)]" required clearable />
            <v-file-input v-model="file" prepend-icon="" accept="image/*" label="사진 첨부" show-size outlined prepend-inner-icon="mdi-paperclip" @change="upload"></v-file-input>
            <v-textarea v-model="head.description" outlined label="설명" :rules="[rule.required, rule.maxLength(200)]" required clearable rows="3" />
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </v-card>
</template>
<script>
import InitLoader from './components/content-skeleton'
import { readAndCompressImage } from 'browser-image-resizer'
import pluralize from 'pluralize'
import BoardArticle from '@/views/board/components/article'
import delay from 'delay'

export default {
  components: { InitLoader, BoardArticle },
  props: ['category', 'content'],
  data () {
    return {
      refHead: null,
      collection: pluralize(this.category),
      loading: false,
      head: {
        category: '',
        title: '',
        subtitle: '',
        description: '',
        thumbnail: '',
        createdAt: null,
        updatedAt: null,
        count: 0
      },
      unsubscribeHead: null,
      dialog: false,
      valid: false,
      embed: '',
      link: '',
      image: '',
      file: null,
      progress: 0,
      dialogArticle: false,
      show: true,
      skeletonLoading: false,
      rule: {
        required: v => !!v || '필수 항목입니다.',
        minLength: length => v => v.length >= length || `${length}자리 이상으로 입력하세요.`,
        maxLength: length => v => v.length <= length || `${length}자리 이하으로 입력하세요.`
      }
    }
  },
  computed: {
  },
  created () {
    this.subscribe()
  },
  destroyed () {
    if (this.unsubscribeHead) this.unsubscribeHead()
    if (this.unsubscribeBody) this.unsubscribeBody()
  },
  watch: {
    content (n, o) {
      this.subscribe()
    }
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    itemRemove (items, i) {
      items.splice(i, 1)
    },
    itemAdd (items, item) {
      if (items.length > 4) throw Error('4개 까지만 등록됩니다')
      items.push(item)
      item = ''
    },
    clear () {
      this.head.category = ''
      this.head.title = ''
      this.head.subtitle = ''
      this.head.description = ''
      this.head.thumbnail = ''
      this.head.createdAt = null
      this.head.updatedAt = null
      this.head.count = 0
    },
    initLoad () {
      this.skeletonLoading = true
      delay(500).then(() => { this.skeletonLoading = false })
    },
    subscribe () {
      this.clear()
      this.initLoad()
      this.loading = true
      this.refHead = this.$firebase.firestore()
        .collection(this.collection)
        .doc(this.content)
      this.unsubscribeHead = this.refHead.onSnapshot((doc) => {
        this.loading = false
        // this.skeletonLoading = false
        if (!doc.exists) {
          // if (this.$store.state.fireUser) this.$store.commit('setEditable', true)
          return
        }
        this.head = doc.data()
      }, this.onError)
      // this.unsubscribeBody = this.refBody.onSnapshot((doc) => {
      //   this.loading = false
      //   if (!doc.exists) return
      //   this.body = doc.data()
      //   // console.log(this.body)
      // })
    },
    openDialog () {
      this.dialog = true
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
    async save () {
      if (!this.$refs.form.validate()) return
      this.head.uid = this.$store.state.fireUser.uid

      this.loading = true
      try {
        if (!this.head.createdAt) this.head.createdAt = new Date()
        if (!this.head.count) this.head.count = 0
        this.head.updatedAt = new Date()
        await this.refHead.set(this.head)
      } finally {
        this.dialog = false
        this.loading = false
      }
    },
    async remove () {
      const r = await this.$swal.fire({
        title: '정말 삭제하시겠습니까?',
        text: '삭제 후 되돌릴 수 없습니다.',
        icon: 'error',
        // confirmButtonText: 'Cool',
        showCancelButton: true
      })
      if (!r.value) return
      this.loading = true
      try {
        // const articles = await this.$firebase.firestore()
        //   .collection(this.collection)
        //   .doc(this.content)
        //   .collection('articles').get()
        await this.refHead.delete()
      } finally {
        this.loading = false
        this.$router.push('/')
      }
    },
    async upload () {
      this.loading = true
      const ref = this.$firebase.storage().ref()
      const config = {
        quality: 0.5,
        maxWidth: 300,
        maxHeight: 300,
        autoRotate: true
      }
      try {
        let image = this.file
        if (this.file.size > 1024 * 1024) image = await readAndCompressImage(this.file, config)
        const fileName = `${this.content}-thumbnail`
        const task = ref.child('images').child(this.collection).child(fileName).put(image)
        task.on(this.$firebase.storage.TaskEvent.STATE_CHANGED, (sn) => {
          this.progress = (sn.bytesTransferred / sn.totalBytes) * 100
          switch (sn.state) {
            case this.$firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused')
              break
            case this.$firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running')
              break
            case this.$firebase.storage.TaskState.PROGRESS: // or 'PROGRESS'
              console.log('Upload is progress')
              break
          }
        }, (err) => {
          this.$toast.error(err.message)
        }, () => {
          console.log('upload fin')
          task.snapshot.ref.getDownloadURL()
            .then((url) => {
              this.head.thumbnail = url
            })
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
